import Swiper from './../plugins/Swiper/dist/js/swiper';

const defaultConfig = {
  pagination: '.swiper-pagination',
  paginationClickable: true,
  a11y: true,
  loop: true,
  keyboardControl: true,
  buttonDisabledClass: 'is-disabled',
  simulateTouch: false,
  navigation: {
    prevEl: '.swiper-prev',
    nextEl: '.swiper-next',
  },
  onInit: swiper => {
    swiper.container[0].classList.add('is-initialized');
  },
};

export default class SwiperSlider {
  constructor(selector = '.swiper-container', config) {
    this.selector = selector;
    this.config = { ...defaultConfig, ...config };

    this.swipers = [];

    return this._init();
  }

  _init() {
    this.swipers = Array.prototype.slice.call(
      document.querySelectorAll(this.selector),
    );

    return this.swipers.map(swiper => {
      const options = swiper.getAttribute('data-swiper-options');
      let swiperConfig = this.config;
      if (options) {
        swiperConfig = { ...this.config, ...JSON.parse(options) };
      }

      return new Swiper(swiper, swiperConfig);
    });
  }
}



// WEBPACK FOOTER //
// ./app/scripts/modules/Swiper.js